"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentList = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var __1 = require("..");
require("./contentList.css");
var ContentList = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "list-drop-down", onClick: props.onCLick }, { children: props.options.map(function (option, index) {
        switch (option.type) {
            case 'title':
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "list-drop-down-title" }, { children: option.label }), "".concat(option.label, "_").concat(index)));
            case 'link':
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "list-drop-down-route ".concat(option.optionIcon ? 'item-icon' : '') }, { children: (0, jsx_runtime_1.jsx)(__1.Button, __assign({ styleType: "minimal", link: option.link, icon: option.optionIcon }, { children: (0, jsx_runtime_1.jsx)("div", { children: option.label }) })) }), "".concat(option.label, "_").concat(index)));
            case 'button':
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('list-drop-down-button', option.defaultHover ? "default-hover" : undefined) }, { children: (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", styleType: option.styleType, onClick: option.onClick, stretch: option.stretch }, { children: (0, jsx_runtime_1.jsx)("div", { children: option.label }) })) }), "".concat(option.label, "_").concat(index)));
        }
    }) }))); };
exports.ContentList = ContentList;
//# sourceMappingURL=ContentList.js.map